import { Fragment } from "react";
import { EditActions, MetaTags, PageLayout, TabPanel } from "../../components";
import useLocales from "../../hooks/useLocales";
import { Outlet } from "react-router-dom";

const CustomerEdit = () => {
  const { translate } = useLocales();
  const panelLabels = [
    { label: translate("tabs.header.general"), path: "customer_general" },
    {
      label: translate("tabs.header.related_person"),
      path: "customer_related_person",
    },
    { label: translate("tabs.header.address"), path: "customer_address" },
    { label: translate("tabs.header.workorders"), path: "customer_workorders" },
    { label: "Faturalar", path: "customer_invoices" },
    {
      label: translate("tabs.header.active_services"),
      path: "customer_products",
    },
    { label: "Fesih Talebi", path: "customer_documents" },
  ];
  return (
    <Fragment>
      <MetaTags title={"Müşteri Bilgileri"} />
      <PageLayout
        title={"Müşteri Bilgileri"}
        actions={
          <EditActions
            path="customers"
            name={translate("actions.list")}
            icon="icon-format_list_bulleted"
          />
        }
      >
        <TabPanel labels={panelLabels}>
          <Outlet></Outlet>
        </TabPanel>
      </PageLayout>
    </Fragment>
  );
};

export default CustomerEdit;
